import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { CustomUiOptionsContext } from '../contexts/custom-ui-options.context';
import { HtmlSanitizerService } from '../services/html-sanitizer.service';

@Component({
  selector: 'ziro-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  standalone: false,
})
export class SupportComponent implements OnInit, OnDestroy {
  private customUiOptionsContext = inject(CustomUiOptionsContext);
  private _htmlSanitizerService = inject(HtmlSanitizerService);

  isLoading = true;
  customizedText: SafeHtml;

  private _subscription = new Subscription();

  ngOnInit(): void {
    this.getUiProperties();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  getUiProperties(): void {
    const uiOptionsSub = this.customUiOptionsContext.state$.subscribe((options) => {
      if (options.supportTextHtml) {
        this.customizedText = this._htmlSanitizerService.sanitizeAndTrustHtml(options.supportTextHtml);
      }
      this.isLoading = false;
    });
    this._subscription.add(uiOptionsSub);
  }
}
